import {
    IonPage,
    IonContent,
    IonSkeletonText,
    IonIcon,
    IonLabel,
    IonCard,
    IonItem,
    IonList,
    IonListHeader,
    IonThumbnail,
    IonImg,
    useIonAlert,
    IonCardContent,
    IonText,
    IonHeader,
    IonToolbar,
    IonButton,
    IonBadge,
    IonRow,
    IonGrid,
    IonCol,
    IonInfiniteScrollContent,
    IonInfiniteScroll,
    useIonToast,
    IonInput,
    useIonModal,
    IonCardTitle,
} from '@ionic/react';
import React, { useState} from 'react';
import { getNameDate, Rupiah, sumByKey, useConstructor } from '../../services/Library';
import { arrowBackOutline,  calendarNumberOutline,  cashOutline, personCircleOutline, receiptOutline, searchOutline, warningOutline } from 'ionicons/icons';
import { RestApi } from '../../services/Api';
import { Customer } from '../../models/Modal'
import { loadList } from '../../models/Data';
import { useTranslation } from 'react-i18next';
import { default as DetailBill } from "./Detail";
import './History.scss';

const History: React.FC<Customer> = (props) =>{
  const [alert] = useIonAlert();
  const { t } = useTranslation(["general"]);
  const [listHistoryBill, setListHistoryBill] = useState<any>([]);
  const [dataHistoryBill, setDataHistoryBill] = useState<any>([]);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);
  const [presentToast] = useIonToast();
  const [searchText, setSearchText] = useState<string>("");
  const [getDetailBill, setGetDetailBill] = useState<any>([]);

  const massageAlert = async (status:string,body:string) => {
    alert({
      header: t(status),
      message: body,
      cssClass: `header-alert-${status}`,
      buttons: [{ text: t('yes'), handler: (d:any) => {} }]
    })
  }

  const getHistoryBill = async (page:string,next:boolean) => {
      await RestApi(`${page}`,'get',{},'application/json')
      .then((res:any) => {
          if (res.data.code === 200) {
            setDataHistoryBill(res.data.data);
            setListHistoryBill(res.data.data.data);
            if (next) {
              setListHistoryBill((prevState: any) => [
                ...prevState,
                ...res.data.data.data,
              ]);
            } else {
              setListHistoryBill(res.data.data.data);
            }
          } else {
            setListHistoryBill([]);
            setDataHistoryBill([]);
            presentToast({
              message: res.data.message,
              duration: 2500,
              color: "danger",
              icon: warningOutline,
            });
          }
          setLoaded(true);
      })
      .catch((err:any) => {
          props.onDismissDetail()
          massageAlert('error',err.message)
          setLoaded(true);
      });
  }

  const statusPayment: any = [
    {
      name: t("no"),
      color: "danger",
    },
    {
      name: t("yes"),
      color: "success",
    },
  ];

  const loadData = (ev: any) => {
    if (dataHistoryBill.current_page === dataHistoryBill.last_page) {
      setInfiniteDisabled(true);
      return;
    }
    getHistoryBill(
      `bill/history-customer/${props.idCustomer}?page=${
        dataHistoryBill.current_page + 1
      }&search=${searchText}`,
      true
    );
    ev.target.complete();
  };

  const onChangeSearch = (e: any) => {
    setSearchText(e.detail.value!);
    getHistoryBill(
      `bill/history-customer/${props.idCustomer}?page=1&search=${searchText}`,
      false
    );
  };

  const [presentBillDetail, dismissBillDetail] = useIonModal(DetailBill, {
    detailBill: getDetailBill,
    onDismissDetail: () => {
      dismissBillDetail();
    },
    type: "bill",
  });
  
  useConstructor(() => {
    getHistoryBill(`bill/history-customer/${props.idCustomer}`,false)
  });

  return (
    <IonPage>
      <IonHeader className="toolbar-history">
        {loaded ? (
          <IonToolbar className="ion-no-padding">
            <IonButton
              color="light"
              slot="start"
              fill="clear"
              onClick={() => props.onDismissDetail()}
            >
              <IonIcon color="light" slot="start" src={arrowBackOutline} />
            </IonButton>
            <div className="search" slot="end">
              <IonItem lines="none" className="item-customer">
                <IonInput
                  placeholder={t("search") + " " + t("module.bill")}
                  className="input-customer"
                  onIonInput={(e) => onChangeSearch(e)}
                ></IonInput>
                <IonIcon src={searchOutline} slot="start" />
                <IonBadge color="medium">{dataHistoryBill.total}</IonBadge>
              </IonItem>
            </div>
          </IonToolbar>
        ) : (
          <IonToolbar>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%" }}
            ></IonSkeletonText>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%" }}
            ></IonSkeletonText>
          </IonToolbar>
        )}
      </IonHeader>
      <IonContent className="content-history">
        {!loaded && (
          <IonList>
            <IonListHeader>
              <IonSkeletonText
                animated={true}
                style={{ width: "80px" }}
              ></IonSkeletonText>
            </IonListHeader>
            {loadList.map((value: any, key: any) => (
              <IonItem key={key}>
                <IonThumbnail slot="start">
                  <IonSkeletonText animated={true}></IonSkeletonText>
                </IonThumbnail>
                <IonLabel>
                  <h3>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "80%" }}
                    ></IonSkeletonText>
                  </h3>
                  <p>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "60%" }}
                    ></IonSkeletonText>
                  </p>
                  <p>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "30%" }}
                    ></IonSkeletonText>
                  </p>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}
        {listHistoryBill.length && loaded ? (
          <IonGrid>
            <IonRow>
              {listHistoryBill.map((bill: any, key: any) => (
                <IonCard key={key}>
                  <IonGrid className="ion-no-padding ion-no-magrin">
                    <IonRow className="ion-no-padding ion-no-margin">
                      <IonCol
                        size="12"
                        className="ion-no-padding ion-no-margin"
                      >
                        <IonCard className="ion-no-padding ion-no-margin">
                          <IonItem
                            color={"medium"}
                            className="ion-no-padding ion-no-margin"
                          >
                            <IonText className="ion-no-padding ion-no-margin">
                              <p className="ion-no-padding ion-no-margin">
                                <IonIcon
                                  size="small"
                                  className="ion-no-padding ion-no-margin"
                                  src={cashOutline}
                                />
                                {t("payment")} ?{" "}
                                <IonBadge
                                  slot="end"
                                  color={
                                    statusPayment[bill.bill_has_receipt].color
                                  }
                                >
                                  {statusPayment[bill.bill_has_receipt].name}
                                </IonBadge>
                              </p>
                              <p className="ion-no-padding ion-no-margin">
                                <IonIcon
                                  size="small"
                                  className="ion-no-padding ion-no-margin"
                                  src={personCircleOutline}
                                />
                                {bill.bill_collector_name}
                              </p>
                            </IonText>
                            <IonText
                              className="ion-no-padding ion-no-margin ion-text-end"
                              slot="end"
                            >
                              <p className="ion-no-padding ion-no-margin">
                                <strong>{bill.bill_id}</strong>
                              </p>
                              <p className="ion-no-padding ion-no-margin">
                                <IonIcon
                                  size="small"
                                  style={{
                                    marginRight: "2px",
                                  }}
                                  src={calendarNumberOutline}
                                />
                                <strong>{getNameDate(bill.bill_date)}</strong>
                              </p>
                            </IonText>
                          </IonItem>

                          <IonCardContent
                            className="ion-no-padding ion-no-margin"
                            color={"medium"}
                          >
                            <IonItem lines="none" color={"medium"}>
                              <IonText className="ion-no-padding ion-no-margin">
                                <p className="ion-no-padding ion-no-margin">
                                  Total {t("invoice")} <br />
                                  {Rupiah(
                                    sumByKey(
                                      bill.billdet,
                                      "billdet_si_total_amount"
                                    )
                                  )}
                                </p>
                                <p className="ion-no-padding ion-no-margin">
                                  Jumlah {t("invoice")} <br />{" "}
                                  {bill.billdet.length}
                                </p>
                              </IonText>
                              <IonText
                                slot="end"
                                className="ion-no-padding ion-text-end"
                              >
                                <p className="ion-no-padding ion-no-margin">
                                  Sisa {t("owing")} <br />
                                  {Rupiah(
                                    sumByKey(
                                      bill.billdet,
                                      "billdet_si_total_owing"
                                    )
                                  )}
                                </p>
                                <p className="ion-no-padding ion-no-margin">
                                  Total {t("payment")} <br />
                                  {Rupiah(
                                    sumByKey(
                                      bill.billdet,
                                      "billdet_si_total_payment"
                                    ) +
                                      sumByKey(
                                        bill.billdet,
                                        "billdet_si_total_allocate"
                                      )
                                  )}
                                </p>
                              </IonText>
                            </IonItem>
                          </IonCardContent>
                        </IonCard>
                      </IonCol>
                      <IonCol
                        size="12"
                        className="ion-no-padding ion-no-margin"
                      >
                        <IonCard>
                          <IonCardTitle
                            color={"dark"}
                            className="ion-no-padding ion-no-margin"
                            style={{
                              backgroundColor: "#f4f5f8",
                              fontSize: "12px",
                            }}
                          >
                            <strong>
                              &nbsp;{`${t("list")} ${t("invoice")}`}
                            </strong>
                          </IonCardTitle>
                          {bill.billdet.map((value: any, key: any) => (
                            <IonCard
                              className="ion-no-padding ion-no-margin"
                              key={key}
                              onClick={() => {
                                setGetDetailBill({
                                  bill_id: bill.bill_id,
                                  customer_id: value.si_customer_id,
                                });
                                presentBillDetail({
                                  cssClass: "modal-fullscreen",
                                });
                              }}
                            >
                              <IonItem>
                                <IonText className="ion-no-padding ion-no-margin">
                                  <p className="ion-no-padding ion-no-margin">
                                    <IonIcon
                                      size="small"
                                      className="ion-no-padding ion-no-margin"
                                      src={receiptOutline}
                                    />
                                    {value.billdet_si_id} (
                                    {value.si_customer_id}{" "}
                                    {value.si_customer_name})
                                  </p>
                                  <p className="ion-no-padding ion-no-margin">
                                    {t("due_date")} :{" "}
                                    {getNameDate(value.billdet_si_due_date)}
                                  </p>
                                </IonText>
                                <IonText
                                  className="ion-no-padding ion-no-margin ion-text-end"
                                  slot="end"
                                >
                                  <p className="ion-no-padding ion-no-margin">
                                    <IonIcon
                                      size="small"
                                      style={{
                                        marginRight: "2px",
                                      }}
                                      src={calendarNumberOutline}
                                    />
                                    <strong>
                                      &nbsp;
                                      {Number(value.billdet_si_overdue_age)}
                                      &nbsp;
                                      {t("day")}
                                    </strong>
                                  </p>
                                </IonText>
                              </IonItem>
                            </IonCard>
                          ))}
                        </IonCard>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonCard>
              ))}
            </IonRow>
          </IonGrid>
        ) : (
          <IonImg className="img-empty" src={"assets/img/search-empty.png"} />
        )}
        <IonInfiniteScroll
          onIonInfinite={loadData}
          threshold="100px"
          disabled={isInfiniteDisabled}
        >
          {dataHistoryBill.next_page_url && (
            <IonInfiniteScrollContent
              loadingSpinner="bubbles"
              loadingText="Loading more data..."
            >
              <IonItem>
                <IonThumbnail slot="start">
                  <IonSkeletonText animated={true}></IonSkeletonText>
                </IonThumbnail>
                <IonLabel>
                  <h3>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "80%" }}
                    ></IonSkeletonText>
                  </h3>
                  <p>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "60%" }}
                    ></IonSkeletonText>
                  </p>
                  <p>
                    <IonSkeletonText
                      animated={true}
                      style={{ width: "30%" }}
                    ></IonSkeletonText>
                  </p>
                </IonLabel>
              </IonItem>
            </IonInfiniteScrollContent>
          )}
        </IonInfiniteScroll>
      </IonContent>
    </IonPage>
  );
};

export default History;
